"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var configuration_1 = require("./configuration");
exports.caughtErrors = mobx_1.observable([]);
function wrapMethodSafely(method) {
    return function () {
        try {
            return method.apply(this, arguments);
        }
        catch (error) {
            exports.caughtErrors.push(error);
            for (var _i = 0, _a = configuration_1.configuration.onCaughtErrorHandlers; _i < _a.length; _i++) {
                var onCaughtError = _a[_i];
                onCaughtError(error);
            }
            throw error;
        }
    };
}
exports.wrapMethodSafely = wrapMethodSafely;
;
